// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"530":"ab5968814e00d8e81ec7","540":"1921dfe2fe7ea2a52038","676":"a813b945cd336ca4a7dd","780":"afd90fab34f778adc45e"}[chunkId] + ".chunk.js";
};